
        <div class="k-window-title k-dialog-title">
            <ng-content></ng-content>
        </div>

        <div class="k-window-actions k-dialog-actions">
            <a
                href="#"
                role="button"
                [attr.title]="closeButtonTitle"
                [attr.aria-label]="closeButtonTitle"
                class="k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close"
                (click)="onCloseClick($event)"
            >
                <span class="k-icon k-i-x"></span>
            </a>
        </div>
    